import React from 'react';

import HeartChunkySvg from 'eventbrite_design_system/iconography/icons/HeartChunky';
import TicketChunkySvg from 'eventbrite_design_system/iconography/icons/TicketChunky';
import BugSvg from 'eventbrite_design_system/iconography/icons/Bug';

import { getAnalyticsClickHandler } from '@eb/site-analytics';

import { gettext } from '@eb/i18n-ebspa';

const ACTION_DISCOVER = 'Discover';
const CATEGORY_HEADER = 'header';

// These were originally exported from core-js-global
// But ever since the refactor to @eb/site-header, they
// seem to have removed these.
export const getLikesQuickLinks = (
    serverUrl,
    ebDomain,
    requestPath,
    publicId,
) => [
    {
        url: `${serverUrl}/u/${publicId}/favorites/events`,
        content: gettext('Likes'),
        iconType: <HeartChunkySvg />,
        iconColor: 'grey-800',
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: ACTION_DISCOVER,
                category: CATEGORY_HEADER,
            },
            {
                checkpointName: 'discover_header_link_clicked',
                domain: ebDomain,
            },
        ),
    },
];

export const getMyTicketsQuickLinks = (
    serverUrl,
    ebDomain,
    requestPath,
    publicId,
) => [
    {
        url: `${serverUrl}/u/${publicId}/`,
        content: gettext('Tickets'),
        iconType: <TicketChunkySvg />,
        iconColor: 'grey-800',
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: ACTION_DISCOVER,
                category: CATEGORY_HEADER,
            },
            {
                checkpointName: 'discover_header_link_clicked',
                domain: ebDomain,
            },
        ),
    },
];

export const getBugQuickLinks = () => [
    {
        url:
            'https://docs.google.com/forms/d/e/1FAIpQLSfgAjPWo5RoQMiChhY1SlrrYycUnUUQjFTPkGAfCc1UCjXyWg/viewform',
        content: gettext('Report a Bug'),
        iconType: <BugSvg />,
    },
];
